<!-- An old ChatKit chat, read only (C0b P5, C0B-DESIGN 3.6), with the Solo composer under it. -->
<div class="legacy-scroll" data-testid="solo-legacy-view">
  <div class="banner" role="note" data-testid="solo-legacy-banner">
    <ion-icon name="archive-outline" aria-hidden="true"></ion-icon>
    <span>{{ t('agents.solo_chat.legacy.banner') }}</span>
  </div>

  @if (loading) {
    <div class="state" role="status" data-testid="solo-legacy-loading"><ion-spinner name="crescent"></ion-spinner><span>{{ t('agents.solo_chat.legacy.loading') }}</span></div>
  } @else if (unavailable) {
    <div class="notice" role="alert" data-testid="solo-legacy-unavailable">
      <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon><span>{{ t('agents.solo_chat.unavailable') }}</span>
    </div>
  } @else if (failed) {
    <div class="notice" role="alert" data-testid="solo-legacy-failed">
      <ion-icon name="alert-circle-outline" aria-hidden="true"></ion-icon><span>{{ t('agents.solo_chat.legacy.failed') }}</span>
      <button type="button" class="link-btn" (click)="load()">{{ t('agents.solo_chat.retry') }}</button>
    </div>
  } @else {
    <h3 class="title" data-testid="solo-legacy-title">{{ title }}</h3>
    <div class="transcript" data-testid="solo-legacy-transcript">
      @for (item of items; track item.key) {
        @if (item.kind === 'user') {
          <div class="mine" data-testid="solo-legacy-user" [attr.title]="item.when">{{ item.text }}</div>
        } @else if (item.kind === 'assistant') {
          <div class="bubble" data-testid="solo-legacy-assistant" [attr.title]="item.when"><app-agents-markdown [text]="item.text"></app-agents-markdown></div>
        } @else if (item.kind === 'card') {
          <div class="card" data-testid="solo-legacy-card" [attr.title]="item.when">{{ item.text }}</div>
        } @else {
          <span class="file" data-testid="solo-legacy-file" [attr.title]="t('agents.solo_chat.legacy.file_hint')">
            <ion-icon name="document-attach-outline" aria-hidden="true"></ion-icon>{{ item.fileName }}
          </span>
        }
      }
    </div>
    @if (hiddenText) { <p class="meta" data-testid="solo-legacy-hidden">{{ hiddenText }}</p> }
    @if (truncated) { <p class="meta" data-testid="solo-legacy-truncated">{{ t('agents.solo_chat.legacy.truncated') }}</p> }
  }
</div>

<form class="composer" data-testid="solo-legacy-composer" (ngSubmit)="send()">
  <textarea name="draft" rows="2" data-testid="solo-legacy-input" [(ngModel)]="draft" [disabled]="sending" [placeholder]="t('agents.solo_chat.legacy.placeholder')"
    [attr.aria-label]="t('agents.solo_chat.legacy.placeholder')" (keydown)="onKey($event)"></textarea>
  <button type="submit" class="send" data-testid="solo-legacy-send" [disabled]="sending || !draft.trim()" [attr.aria-label]="t('agents.solo_chat.legacy.send')"
    [title]="t('agents.solo_chat.legacy.send')"><ion-icon name="arrow-up-outline" aria-hidden="true"></ion-icon></button>
</form>
